import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconBebidasOn(props) {
    return (
        <svg
            width={242}
            height={243}
            viewBox="0 0 242 243"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx={121} cy={120} r={117} fill="#000" />
            <path
            d="M117.675 108.862l-12.229-24.996V45.848c0-2.397-1.857-4.255-4.253-4.255h-9.834c-2.396 0-4.253 1.858-4.253 4.255v39.087l-11.96 24.197c-.799 1.857-1.597 3.185-1.857 3.725-1.058.798-1.058 2.926-1.058 7.449v74.449c0 2.397 1.857 4.254 4.253 4.254h39.345c2.396 0 4.253-1.857 4.253-4.254v-78.982c.519-1.059-.01-2.118-2.407-6.911zM92.158 46.637h7.977V72.7h-7.977V46.637zm22.862 131.371H89.762v-51.061h25.258v51.061zm0-57.712v1.329H87.106c-1.328 0-2.656 1.328-2.656 2.656v56.373c0 1.328 1.328 2.657 2.656 2.657h27.914v10.366H77.802v-77.914c.529-.799 1.327-2.397 2.395-4.524l11.96-24.467c.27-.53.53-1.328.53-1.857v-6.901h7.977v6.122c0 .529.269 1.328.529 1.857l12.229 25.266c.799 1.867 1.598 3.455 2.127 4.254-.529 1.068-.529 2.656-.529 4.783zM167.653 193.157l-14.885-6.91v-39.886c9.304-1.328 16.482-9.308 16.482-18.885V97.427c0-1.597-1.328-2.656-2.655-2.656-1.598 0-2.656 1.059-2.656 2.656v19.144c-1.058 0-1.857-.529-2.656-1.058-1.327-.799-2.925-1.598-5.85-1.598s-4.522.799-5.85 1.598c-1.059.529-1.857 1.058-3.724 1.058-1.857 0-2.656-.529-3.724-1.058-1.328-.53-2.656-1.598-5.581-1.598V97.427c0-1.597-1.328-2.656-2.655-2.656-1.328 0-2.656 1.059-2.656 2.656v29.78c0 9.577 7.178 17.556 16.483 18.884v39.886l-15.155 6.91c-1.068.53-1.857 1.858-1.328 2.926.27 1.329 1.328 2.128 2.656 2.128h33.225c1.328 0 2.655-1.329 2.655-2.657-.269-.789-1.068-1.857-2.126-2.127zm-31.099-65.681v-7.979c1.598 0 2.396.53 3.455 1.059 1.327.799 2.925 1.598 5.85 1.598s4.522-.799 5.85-1.598c1.058-.529 1.857-1.059 3.724-1.059 1.857 0 2.656.53 3.724 1.059 1.068.529 2.396 1.328 4.782 1.598v5.322c0 7.45-6.11 13.832-13.827 13.832-7.448-.27-13.558-6.382-13.558-13.832zm9.035 65.681l4.782-2.127 4.783 2.127h-9.565z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeWidth={0.5}
            strokeMiterlimit={10}
            />
            <path
            d="M121 242.081c-66.73 0-121-54.297-121-121.036C0 54.316 54.28 0 121 0c66.73 0 121 54.306 121 121.045s-54.27 121.036-121 121.036zm0-235.32C58.004 6.76 6.759 58.02 6.759 121.035 6.759 184.05 58.004 235.31 121 235.31c62.986 0 114.241-51.26 114.241-114.275C235.241 58.031 183.986 6.761 121 6.761z"
            fill="#000"
            />
            <path
            d="M183.397 38.977c-1.158-10.645 6.559-20.202 17.181-21.36 10.643-1.16 20.187 6.53 21.345 17.176 1.158 10.625-6.519 20.202-17.161 21.36-10.623 1.15-20.207-6.55-21.365-17.176z"
            fill="#000"
            />
            <path
            d="M193.063 36.558c-.629-5.742 3.504-10.866 9.255-11.495a10.391 10.391 0 0111.491 9.238 10.422 10.422 0 01-9.245 11.494c-5.74.62-10.882-3.525-11.501-9.237z"
            fill="#FFDD00"
            />
        </svg>
    )
}

export default SvgIconBebidasOn;